document.addEventListener("click", (e) => {
  const trigger = e.target.closest("[data-sp-nav-trigger]");
  const anyGroup = e.target.closest(".sp-nav-group");

  document.querySelectorAll(".sp-nav-group.is-open").forEach((el) => {
    if (!anyGroup || el !== anyGroup) el.classList.remove("is-open");
  });

  if (trigger) {
    const group = trigger.closest(".sp-nav-group");
    group.classList.toggle("is-open");
  }
});

(function () {
  function initCarousel(root) {
    const track = root.querySelector("[data-sp-carousel-track]");
    const slides = Array.from(root.querySelectorAll("[data-sp-carousel-slide]"));
    const prevBtn = root.querySelector("[data-sp-carousel-prev]");
    const nextBtn = root.querySelector("[data-sp-carousel-next]");
    const dotsWrap = root.querySelector("[data-sp-carousel-dots]");

    if (!track || slides.length === 0) return;

    const autoplay = root.dataset.autoplay === "true";
    const intervalMs = Number(root.dataset.interval || "5000");
    const showDots = root.dataset.dots === "true";

    let index = 0;
    let timer = null;
    let startX = null;
    let deltaX = 0;

    function clamp(i) {
      if (i < 0) return slides.length - 1;
      if (i >= slides.length) return 0;
      return i;
    }

    function setIndex(next) {
      index = clamp(next);
      track.style.transform = `translateX(${index * -100}%)`;

      if (showDots && dotsWrap) {
        const dots = Array.from(dotsWrap.querySelectorAll("button"));
        dots.forEach((d, i) => d.setAttribute("aria-current", i === index ? "true" : "false"));
      }
    }

    function start() {
      if (!autoplay) return;
      stop();
      timer = window.setInterval(() => setIndex(index + 1), intervalMs);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    if (showDots && dotsWrap) {
      dotsWrap.innerHTML = "";
      slides.forEach((_, i) => {
        const btn = document.createElement("button");
        btn.className = "sp-carousel-dot";
        btn.type = "button";
        btn.setAttribute("aria-label", `Go to slide ${i + 1}`);
        btn.setAttribute("aria-current", i === 0 ? "true" : "false");
        btn.addEventListener("click", () => {
          setIndex(i);
          start();
        });
        dotsWrap.appendChild(btn);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", () => {
        setIndex(index - 1);
        start();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", () => {
        setIndex(index + 1);
        start();
      });
    }

    // Touch swipe
    root.addEventListener("touchstart", (e) => {
      stop();
      startX = e.touches[0].clientX;
      deltaX = 0;
    }, { passive: true });

    root.addEventListener("touchmove", (e) => {
      if (startX == null) return;
      deltaX = e.touches[0].clientX - startX;
    }, { passive: true });

    root.addEventListener("touchend", () => {
      if (startX == null) return;
      const threshold = 45;
      if (deltaX > threshold) setIndex(index - 1);
      if (deltaX < -threshold) setIndex(index + 1);
      startX = null;
      deltaX = 0;
      start();
    });

    // Pause on hover (desktop)
    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);

    // Init
    setIndex(0);
    start();
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-sp-carousel]").forEach(initCarousel);
  });
})();
